import ActiveAccount from "./ActiveAccount";

export default ActiveAccount;
